import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { AffCode } from 'src/app/affcode/shared/affcode.model';
import { AffCodeService } from 'src/app/affcode/shared/affcode.service';
import { NotificationService } from 'src/app/shared';
import { WebContentType } from 'src/app/shared/model/webcontenttype.model';
import { WebContentAffCodeDto } from 'src/app/web-content/shared/dto/web-content-aff-code.dto';
import { WebContentDto } from 'src/app/web-content/shared/dto/web-content.dto';
import { WebContentFormatEnum } from 'src/app/web-content/shared/enum/web-content-format.enum';
import { WebContentTypeService } from 'src/app/web-content/shared/web-content-type.service';
import { WebContentService } from 'src/app/web-content/shared/web-content.service';

@Component({
  selector: 'wl-ecom-web-content-edit',
  templateUrl: './ecom-web-content-edit.component.html',
  styleUrls: ['./ecom-web-content-edit.component.less'],
    standalone: false
})
export class EComWebContentEditComponent implements OnInit {
  @Input() profileId: number;
  @Input() isReadOnly: boolean;
  @Output() showChange: EventEmitter<boolean> = new EventEmitter();
  @Output() webContentSaved: EventEmitter<WebContentDto> = new EventEmitter();

  webContentRecord: WebContentDto;
  webContentTypes: WebContentType[] = [];
  webContentFormats: string[] = [];
  webContentFormatEnum = WebContentFormatEnum;
  fileToUpload: File;
  isSaving = false;
  showAccessTextArea = false;
  allAffCodes: AffCode[];
  affCodeSearchResults: AffCode[];
  selectedAffCodes: AffCode[] = [];
  affCodesToDelete: WebContentAffCodeDto[] = [];

  constructor(
    private _webContentTypeService: WebContentTypeService,
    private _webContentService: WebContentService,
    private _notificationService: NotificationService,
    private _affCodeService: AffCodeService
  ) {
    this.webContentRecord = {} as WebContentDto;
  }

  ngOnInit(): void {
    this._webContentTypeService.getWebContentTypes().then((typesResult) => {
      this.webContentTypes = typesResult.Result;
    });

    this._webContentService.getWebContentFormats().then((formats) => {
      this.webContentFormats = formats;
    });

    this._affCodeService.getAllAffCodes().then((affCodes) => {
      this.allAffCodes = affCodes;
    });
  }

  fileSelected(event: any) {
    const file = event.target.files[0];
    this.fileToUpload = file;
  }

  save() {
    this.isSaving = true;
    this.webContentRecord.RestrictForAffiliations = false;
    if (this.webContentRecord.WebContentAffCodes?.length > 0) {
      this.webContentRecord.RestrictForAffiliations = true;
    }

    this._webContentService.create(this.webContentRecord, this.fileToUpload).then(
      (id) => {
        this.isSaving = false;
        this.webContentRecord.ContentID = id;
        this._notificationService.translateSuccess('web-content.edit.notifications.save-success');
        this.webContentSaved.emit(this.webContentRecord);
        this.clearData();
      },
      (error) => {
        this._notificationService.httpError(error);
        this.isSaving = false;
      }
    );
  }

  searchAffCodes(searchEvent: any) {
    this.affCodeSearchResults = this.allAffCodes
      ?.filter((ac) => ac.AffCode.toLowerCase().includes(searchEvent.query?.toLowerCase()))
      .filter((x) => !this.selectedAffCodes?.find((y) => x === y));
  }

  addAffCode(affCode: AffCode) {
    if (!this.webContentRecord.WebContentAffCodes) {
      this.webContentRecord.WebContentAffCodes = [];
    }
    this.webContentRecord.WebContentAffCodes.push({ AffCode: affCode.AffCode } as WebContentAffCodeDto);
  }

  deleteAffCode(affCode: AffCode) {
    const webContentAffCode = this.webContentRecord.WebContentAffCodes?.find((x) => x.AffCode === affCode.AffCode);
    if (webContentAffCode) {
      if (webContentAffCode.ID) {
        this.affCodesToDelete.push(webContentAffCode);
      }
      const index = this.webContentRecord.WebContentAffCodes.findIndex((x) => x.ID === webContentAffCode.ID);
      this.webContentRecord.WebContentAffCodes.splice(index, 1);
    }
  }

  private loadWebContentRecord(webContentId: number) {
    this._webContentService.getWebContent(webContentId, true).then((webContentRecord) => {
      this.webContentRecord = webContentRecord;
      if (!this.webContentFormats.find((x) => x === webContentRecord.ContentFormat)) {
        this.webContentFormats.push(webContentRecord.ContentFormat);
      }
      if (this.webContentRecord.WebContentAffCodes?.length > 0) {
        this.selectedAffCodes = [];
        this.webContentRecord.WebContentAffCodes.forEach((affCode) => {
          this.selectedAffCodes.push(this.allAffCodes.find((x) => x.AffCode === affCode.AffCode));
        });
      }
      if (this.webContentRecord.RestrictForAffiliations || this.webContentRecord.RestrictForMembersOnly) {
        this.showAccessTextArea = true;
      }
    });
  }

  clearData() {
    this.webContentRecord = {} as WebContentDto;
    if (this.profileId) {
      this.webContentRecord.ProfileID = this.profileId;
    }
    this.affCodesToDelete = [];
    this.selectedAffCodes = [];
    this.showAccessTextArea = false;
    this.fileToUpload = null;
  }
}
